import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7ec356a3")

_pushScopeId("data-v-7ec356a3")
const _hoisted_1 = { class: "answer-container" }
const _hoisted_2 = { class: "cover-wrapper" }
const _hoisted_3 = { class: "award-info" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "award-title" }, [
  /*#__PURE__*/_createVNode("span", null, "苹果X"),
  /*#__PURE__*/_createVNode("span", null, "已发货")
], -1)
const _hoisted_5 = { class: "award-img" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "收货人", -1)
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "手机号码", -1)
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "所在地区", -1)
const _hoisted_12 = { class: "form-item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "详细地址", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Back = _resolveComponent("Back")
  const _component_Action = _resolveComponent("Action")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, {
    circleRight: true,
    circleTop: true,
    flower: true,
    spot: true,
    starTop: true,
    starMiddle: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { text: `奖品兑换` }),
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: `${_ctx.rootUrl}/answer/daily_cover.png`
              }, null, 8, ["src"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("input", {
              placeholder: "请填写收货人姓名",
              value: _ctx.name
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("input", {
              placeholder: "请填写联系人手机号码",
              value: _ctx.mobile
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("input", {
              placeholder: "请选择",
              value: _ctx.area
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("input", {
              placeholder: "街道，楼牌号等",
              value: _ctx.address
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode(_component_Action, { text: `确定` })
      ])
    ]),
    _: 1
  }))
})